import { BACKGROUND_TEXT_MODE } from '../../../constants';
import type { TextElement } from '../../types';

export function getSvgTextVerticalPosition({
  backgroundTextMode,
  marginOffsetTop,
  verticalPadding,
  verticalTrim,
}: {
  backgroundTextMode: TextElement['backgroundTextMode'];
  marginOffsetTop: number;
  verticalPadding: number;
  verticalTrim: TextElement['verticalTrim'];
}) {
  const isHighlight = backgroundTextMode === BACKGROUND_TEXT_MODE.HIGHLIGHT;
  const isBaselineTrim = verticalTrim === 'baseline';
  const glyphTopOffset = -marginOffsetTop;
  const marginTop = isHighlight
    ? 0
    : isBaselineTrim
    ? Math.min(glyphTopOffset, 0)
    : glyphTopOffset;

  return {
    // Highlight SVGs share the same margined wrapper as their HTML background.
    // Keeping both at the same local padding centers the glyphs in the cloned
    // highlight bands for every line height and trim mode.
    top: verticalPadding,
    // Convert the SVG's baseline-based coordinates to the trimmed text frame.
    // Baseline trim retains its negative-leading clamp.
    marginTop,
    // Edit mode nests the SVG inside the editable text wrapper. Keep that
    // wrapper on the same margin policy as generated output instead of adding
    // another margin directly to the SVG.
    wrapperMarginTop: isHighlight ? -marginOffsetTop : marginTop,
  };
}
